import React, { useEffect, useState } from 'react';
import { notification, Button, Modal, Form, Input, Spin, Select } from 'antd';
import { MdAddCircleOutline } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { Row, Col } from 'react-bootstrap';
import axios from 'axios'; // Use axios to make API calls
import { connect } from 'react-redux';
import { updateSubscriptionRequest } from '../../store/action/admin/SubscriptionAction';

const SubscriptionEditModel = ({ 
  updateSubscription, 
  subscriptionState, 
  subscriptionId, 
  onCancel, 
  isModalOpen 
}) => {
  const [form] = Form.useForm();
  const [listItems, setListItems] = useState([]); // To store the list of plans
  const [inputValue, setInputValue] = useState(''); // To track the input value
  const [isSubmitting, setIsSubmitting] = useState(false); // Flag to track form submission
  const [loadings, setLoading] = useState(false); // To handle loading state

  const { loading, response, error } = subscriptionState;

  // Fetch subscription details by ID when the modal opens
  useEffect(() => {
    if (isModalOpen && subscriptionId) {
      fetchSubscriptionDetails();
    }
  }, [isModalOpen, subscriptionId]);

  const fetchSubscriptionDetails = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem('accessToken');
      if (!token) {
        throw new Error('Access token not found. Please log in again.');
      }

      const response = await axios.get(
       `https://verse.blaccdot.com/ldsbackendindia/masters/subscription/edit/${subscriptionId}`,
        { headers: { Authorization: `${token}` } }
      );

      const data = response.data?.data?.subscriptionmaster;
      if (data) {
        form.setFieldsValue({
          planname: data.title,
          planAmountMonthly: data.monthAmount,
          planAmountYearly: data.anualAmount,
          taxAmount: data.taxAmount,
          leadCount: data.creditpoints,
          selectdmoin: data.categoryName,
          currencycode: data.currency,
        });

        const descriptions = Object.values(data.textcontent || {});
        setListItems(descriptions);
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error.message || 'Failed to fetch subscription details.',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = (index) => {
    const updatedItems = listItems.filter((_, i) => i !== index);
    setListItems(updatedItems);
  };

  const handleAddPlan = () => {
    if (inputValue.trim() !== '') {
      // Add the input value to the list and reset the input field
      setListItems([...listItems, inputValue]);
      setInputValue('');
    } else {
      notification.warning({
        message: 'Validation Error',
        description: 'Please enter a valid plan name!',
      });
    }
  };

  // Show notifications only after submitting
  useEffect(() => {
    if (isSubmitting) {
      if (response) {
        notification.success({
          message: 'Success',
          description: 'Subscription updated successfully!',
        });
        setIsSubmitting(false); // Reset the flag
      }
      if (error) {
        notification.error({
          message: 'Error',
          description: error || 'Something went wrong!',
        });
        setIsSubmitting(false); // Reset the flag
      }
    }
  }, [response, error, isSubmitting]);

  const onFinish = (values) => {
    if (listItems.length === 0) {
      notification.warning({
        message: 'Validation Error',
        description: 'Please add at least one plan to the list!',
      });
      return;
    }
    const payload = {
      title: values.planname,
      monthAmount: values.planAmountMonthly,
      anualAmount: values.anualAmount,
      taxAmount: values.taxAmount,
      creditpoints: values.leadCount,
      category: parseInt(values.selectdmoin, 10),
      country: 1,
      currency: values.currencycode,
      textcontent: listItems.reduce((obj, item, index) => {
        obj[`plan${index + 1}`] = item; // Create textcontent dynamically
        return obj;
      }, {}),
    };
    setIsSubmitting(true); // Set the flag to true when the form is submitted
    updateSubscription(subscriptionId, payload); // Dispatch the update action
    console.log('My Testing', payload)
    onCancel();
  };

  return (
    <Modal
      width={1000}
      title="Edit Subscription"
      open={isModalOpen}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" loading={loadings} onClick={() => form.submit()}>
          Submit
        </Button>,
      ]}
    >
      <Spin spinning={loadings}>
        <hr />
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Row>
            <Col md={4}>
              <Form.Item
                name="planname"
                label="Plan Name (Title)"
                rules={[{ required: true, message: 'Please input your Plan Name!' }]}>
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col md={4}>
            <Form.Item
                name="selectdmoin"
                label="Select a Domain"
                rules={[{ required: true, message: 'Please select country!' }]} >
            <Select showSearch placeholder="Select a country" style={{width:'100%'}}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              options={[
                {
                  value: '1',
                  label: 'Health Care',
                },
                {
                  value: '2',
                  label: 'Movers',
                },
                {
                  value: '3',
                  label: 'Financial Service',
                },
                {
                  value: '4',
                  label: 'Manufacturing',
                },
                {
                  value: '5',
                  label: 'Real Estate',
                },
                {
                  value: '6',
                  label: 'E-Commerce',
                },]}/>
                </Form.Item>
            </Col>
            <Col md={4}>
                <Form.Item
                 name="currencycode"
                 label="Enter currency code"
                 rules={[{ required: true, message: 'Please input your currency code!' }]} >
                 <Input size="large" />
                </Form.Item>
            </Col>
            <Col md={4}>
              <Form.Item
                name="planAmountMonthly"
                label="Plan Amount"
                rules={[{ required: true, message: 'Please input your Plan Amount!' }]} >
                <Input type="number" size="large" />
              </Form.Item>
            </Col>
            <Col md={4}>
              <Form.Item
                name="taxAmount"
                label="Tax Amount"
                rules={[{ required: true, message: 'Please input your Plan Amount!' }]}>
                <Input type="number" size="large" />
              </Form.Item>
            </Col>

            <Col md={4}>
              <Form.Item
                name="leadCount"
                label="Number of Credit"
                rules={[{ required: true, message: 'Please input your lead count!' }]}
              >
                <Input type="number" size="large" />
              </Form.Item>
            </Col>
            <Col md={8}>
              <Form.Item name="planList" label="Plan List">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Input
                    value={inputValue}
                    size="large"
                    onChange={(e) => setInputValue(e.target.value)}
                    type="text"
                  />
                  <button type="button" className="button-15" onClick={handleAddPlan}>
                    <MdAddCircleOutline size={20} /> ADD PLANS
                  </button>
                </div>
              </Form.Item>
            </Col>
          </Row>
          <div>
            {listItems.map((item, index) => (
              <div key={index} className="list-box" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>{item}</span>
                <IoIosCloseCircleOutline
                  className="close-icon"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleRemove(index)}
                />
              </div>
            ))}
          </div>
        </Form>
      </Spin>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  subscriptionState: state.subscriptionState,
});

const mapDispatchToProps = (dispatch) => ({
  updateSubscription: (id, payload) => dispatch(updateSubscriptionRequest(id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionEditModel);

// import React, { useEffect, useState } from 'react';
// import { notification, Button, Modal, Form, Input, Spin } from 'antd';
// import { MdAddCircleOutline } from "react-icons/md";
// import { IoIosCloseCircleOutline } from "react-icons/io";
// import { Row, Col } from 'react-bootstrap';
// import axios from 'axios'; // Use axios to make API calls
// import { connect } from 'react-redux';
// import { updateSubscriptionRequest } from '../../store/action/admin/SubscriptionAction';

// const SubscriptionEditModel = ({ 
//   updateSubscription, 
//   subscriptionState, 
//   subscriptionId, 
//   onCancel, 
//   isModalOpen 
// }) => {
//   const [form] = Form.useForm();
//   const [listItems, setListItems] = useState([]); // To store the list of plans
//   const [inputValue, setInputValue] = useState(''); // To track the input value
//   const [isSubmitting, setIsSubmitting] = useState(false); // Flag to track form submission
//   const [loadings, setLoading] = useState(false); // To handle loading state

//   const { loading, response, error } = subscriptionState;

//   // Fetch subscription details by ID when the modal opens
//   useEffect(() => {
//     if (isModalOpen && subscriptionId) {
//       fetchSubscriptionDetails();
//     }
//   }, [isModalOpen, subscriptionId]);

//   const fetchSubscriptionDetails = async () => {
//     try {
//       setLoading(true);

//       const token = localStorage.getItem('accessToken');
//       if (!token) {
//         throw new Error('Access token not found. Please log in again.');
//       }

//       const response = await axios.get(
//        `https://verse.blaccdot.com/ldsbackendindia/masters/subscription/edit/${subscriptionId}`,
//         { headers: { Authorization: `${token}` } }
//       );

//       const data = response.data?.data?.subscriptionmaster;
//       if (data) {
//         form.setFieldsValue({
//           planname: data.title,
//           planAmountMonthly: data.monthAmount,
//           planAmountYearly: data.anualAmount,
//           taxAmount: data.taxAmount,
//           leadCount: data.creditpoints,
//         });

//         const descriptions = Object.values(data.textcontent || {});
//         setListItems(descriptions);
//       }
//     } catch (error) {
//       notification.error({
//         message: 'Error',
//         description: error.message || 'Failed to fetch subscription details.',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleRemove = (index) => {
//     const updatedItems = listItems.filter((_, i) => i !== index);
//     setListItems(updatedItems);
//   };

//   const handleAddPlan = () => {
//     if (inputValue.trim() !== '') {
//       // Add the input value to the list and reset the input field
//       setListItems([...listItems, inputValue]);
//       setInputValue('');
//     } else {
//       notification.warning({
//         message: 'Validation Error',
//         description: 'Please enter a valid plan name!',
//       });
//     }
//   };

//   // Show notifications only after submitting
//   useEffect(() => {
//     if (isSubmitting) {
//       if (response) {
//         notification.success({
//           message: 'Success',
//           description: 'Subscription updated successfully!',
//         });
//         setIsSubmitting(false); // Reset the flag
//       }
//       if (error) {
//         notification.error({
//           message: 'Error',
//           description: error || 'Something went wrong!',
//         });
//         setIsSubmitting(false); // Reset the flag
//       }
//     }
//   }, [response, error, isSubmitting]);

//   const onFinish = (values) => {
//     if (listItems.length === 0) {
//       notification.warning({
//         message: 'Validation Error',
//         description: 'Please add at least one plan to the list!',
//       });
//       return;
//     }
//     const payload = {
//       title: values.planname,
//       monthAmount: values.planAmountMonthly,
//       anualAmount: values.anualAmount,
//       taxAmount: values.taxAmount,
//       creditpoints: values.leadCount,
//       textcontent: listItems.reduce((obj, item, index) => {
//         obj[`plan${index + 1}`] = item; // Create textcontent dynamically
//         return obj;
//       }, {}),
//     };
//     setIsSubmitting(true); // Set the flag to true when the form is submitted
//     updateSubscription(subscriptionId, payload); // Dispatch the update action
//     console.log('My Testing', payload)
//     onCancel();
//   };

//   return (
//     <Modal
//       width={1000}
//       title="Edit Subscription"
//       open={isModalOpen}
//       onCancel={onCancel}
//       footer={[
//         <Button key="cancel" onClick={onCancel}>
//           Cancel
//         </Button>,
//         <Button key="submit" type="primary" loading={loadings} onClick={() => form.submit()}>
//           Submit
//         </Button>,
//       ]}
//     >
//       <Spin spinning={loadings}>
//         <hr />
//         <Form layout="vertical" form={form} onFinish={onFinish}>
//           <Row>
//             <Col md={4}>
//               <Form.Item
//                 name="planname"
//                 label="Plan Name (Title)"
//                 rules={[{ required: true, message: 'Please input your Plan Name!' }]}
//               >
//                 <Input size="large" />
//               </Form.Item>
//             </Col>
//             <Col md={4}>
//               <Form.Item
//                 name="planAmountMonthly"
//                 label="Plan Amount"
//                 rules={[{ required: true, message: 'Please input your Plan Amount!' }]}
//               >
//                 <Input type="number" size="large" />
//               </Form.Item>
//             </Col>
//             <Col md={4}>
//               <Form.Item
//                 name="taxAmount"
//                 label="Tax Amount"
//                 rules={[{ required: true, message: 'Please input your Plan Amount!' }]}
//               >
//                 <Input type="number" size="large" />
//               </Form.Item>
//             </Col>

//             <Col md={4}>
//               <Form.Item
//                 name="leadCount"
//                 label="Number of Credit"
//                 rules={[{ required: true, message: 'Please input your lead count!' }]}
//               >
//                 <Input type="number" size="large" />
//               </Form.Item>
//             </Col>
//             <Col md={8}>
//               <Form.Item name="planList" label="Plan List">
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <Input
//                     value={inputValue}
//                     size="large"
//                     onChange={(e) => setInputValue(e.target.value)}
//                     type="text"
//                   />
//                   <button type="button" className="button-15" onClick={handleAddPlan}>
//                     <MdAddCircleOutline size={20} /> ADD PLANS
//                   </button>
//                 </div>
//               </Form.Item>
//             </Col>
//           </Row>
//           <div>
//             {listItems.map((item, index) => (
//               <div key={index} className="list-box" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                 <span>{item}</span>
//                 <IoIosCloseCircleOutline
//                   className="close-icon"
//                   style={{ cursor: 'pointer' }}
//                   onClick={() => handleRemove(index)}
//                 />
//               </div>
//             ))}
//           </div>
//         </Form>
//       </Spin>
//     </Modal>
//   );
// };

// const mapStateToProps = (state) => ({
//   subscriptionState: state.subscriptionState,
// });

// const mapDispatchToProps = (dispatch) => ({
//   updateSubscription: (id, payload) => dispatch(updateSubscriptionRequest(id, payload)),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionEditModel);

